export default "__VITE_ASSET__D0sQtHk5__"